module.exports = __webpack_public_path__ + "media/metronic/_theme/media/demos/preview/demo5-4ac82728e2be534c15cf2be5c088f5d6.jpg";